/* ====================================================================================================================
 * FAYARD CUSTOM — Liste de favoris (liste de souhaits)
 * --------------------------------------------------------------------------------------------------------------------
 * Fonctionnement classique des boutiques en ligne : la liste est gardée dans le navigateur du client (localStorage),
 * sans compte ni expiration. Elle se vide seulement si le client efface les données de son navigateur.
 *
 * - Cœur sur la photo de la fiche produit et sur chaque carte produit (product-card[handle]).
 * - Icône cœur dans l'en-tête (snippets/fayard-favoris-entete.liquid) : pastille dès qu'il y a un favori.
 * - Page « Mes favoris » (sections/fayard-favoris.liquid) : les cartes sont rendues par le thème lui-même via
 *   templates/product.fy-carte.liquid (?view=fy-carte), donc identiques au reste du site.
 * - Synchronisé entre onglets (événement storage). Chaque ajout est signalé à Klaviyo (« Added to Wishlist »).
 * ==================================================================================================================== */
(function () {
  if (window.fyFavoris) return;

  var KEY = 'fy-favoris';
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var TEXT = EN
    ? { add: 'Add to wishlist', remove: 'Remove from wishlist' }
    : { add: 'Ajouter aux favoris', remove: 'Retirer des favoris' };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.25s-7.5-4.6-7.5-10.05A4.2 4.2 0 0 1 8.7 6c1.4 0 2.6.7 3.3 1.8C12.7 6.7 13.9 6 15.3 6a4.2 4.2 0 0 1 4.2 4.2c0 5.45-7.5 10.05-7.5 10.05Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

  /* Mémoire
   * ---------------------------------------------------------------------------------------------------------------- */
  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    refresh();
    document.dispatchEvent(new CustomEvent('fy:favoris', { detail: { handles: list.slice() } }));
  }

  function has(handle) {
    return read().indexOf(handle) > -1;
  }

  function toggle(handle, name) {
    var list = read();
    var index = list.indexOf(handle);
    var added = index === -1;
    if (added) list.unshift(handle);
    else list.splice(index, 1);
    write(list);
    if (added) track(handle, name);
    return added;
  }

  function track(handle, name) {
    try {
      var klaviyo = window.klaviyo || (window._learnq = window._learnq || []);
      klaviyo.push(['track', 'Added to Wishlist', {
        ProductHandle: handle,
        ProductName: name || '',
        URL: location.origin + ROOT.replace(/\/$/, '') + '/products/' + handle
      }]);
    } catch (e) {}
  }

  /* Boutons cœur
   * ---------------------------------------------------------------------------------------------------------------- */
  function paint(button) {
    var on = has(button.dataset.fyFav);
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.setAttribute('aria-label', on ? TEXT.remove : TEXT.add);
  }

  function makeButton(handle, variant, name) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fy-fav fy-fav--' + variant;
    button.dataset.fyFav = handle;
    if (name) button.dataset.fyFavName = name;
    button.innerHTML = HEART;
    paint(button);
    return button;
  }

  function refresh() {
    var count = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-fy-fav]'), paint);
    Array.prototype.forEach.call(document.querySelectorAll('[data-fy-fav-dot]'), function (dot) {
      dot.classList.toggle('is-visible', count > 0);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-fy-fav-count]'), function (el) {
      // data-one / data-many : phrase au singulier / pluriel, [n] = nombre ; masquée quand la liste est vide
      var template = count > 1 ? el.dataset.many : el.dataset.one;
      el.textContent = template ? template.replace('[n]', count) : String(count);
      if (template) el.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-fy-fav]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var added = toggle(button.dataset.fyFav, button.dataset.fyFavName);
    button.classList.remove('is-popping');
    void button.offsetWidth;
    if (added) button.classList.add('is-popping');

    var headerLink = document.querySelector('.header__wishlist-link a');
    if (headerLink && added) {
      headerLink.classList.remove('is-bumping');
      void headerLink.offsetWidth;
      headerLink.classList.add('is-bumping');
    }

    // Sur la page des favoris, la carte retirée s'efface.
    if (!added) {
      var card = button.closest('[data-fy-favoris-grid] product-card');
      if (card) removeCard(card);
    }
  }, true);

  // Liste modifiée dans un autre onglet.
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) refresh();
  });

  /* Cartes produit et fiche produit
   * ---------------------------------------------------------------------------------------------------------------- */
  function decorateCard(card) {
    if (card.dataset.fyFavReady) return;
    var handle = card.getAttribute('handle');
    var figure = card.querySelector('.product-card__figure');
    if (!handle || !figure) return;
    card.dataset.fyFavReady = '1';
    var title = card.querySelector('.product-title');
    figure.appendChild(makeButton(handle, 'card', title ? title.textContent.trim() : ''));
  }

  function decorateProductPage() {
    var match = location.pathname.match(/\/products\/([^/?#]+)/);
    var list = document.querySelector('.product-gallery__image-list');
    if (!match || !list || list.dataset.fyFavReady) return;
    list.dataset.fyFavReady = '1';
    var heading = document.querySelector('.product-info h1, .product-info .product-title');
    list.appendChild(makeButton(decodeURIComponent(match[1]), 'pdp', heading ? heading.textContent.trim() : ''));
  }

  function decorate(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('product-card')) decorateCard(root);
    Array.prototype.forEach.call(root.querySelectorAll('product-card'), decorateCard);
    decorateProductPage();
  }

  /* Page « Mes favoris »
   * ---------------------------------------------------------------------------------------------------------------- */
  var page = document.querySelector('[data-fy-favoris-page]');

  function showState(state) {
    if (!page) return;
    page.querySelector('[data-fy-favoris-loading]').hidden = state !== 'loading';
    page.querySelector('[data-fy-favoris-empty]').hidden = state !== 'empty';
    page.querySelector('[data-fy-favoris-grid]').hidden = state !== 'list';
  }

  function removeCard(card) {
    card.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
    card.style.opacity = '0';
    card.style.transform = 'scale(0.97)';
    setTimeout(function () {
      card.remove();
      if (!read().length) showState('empty');
    }, 250);
  }

  async function renderPage() {
    if (!page) return;
    var handles = read();
    if (!handles.length) { showState('empty'); return; }
    showState('loading');

    var grid = page.querySelector('[data-fy-favoris-grid]');
    var results = await Promise.all(handles.map(function (handle) {
      return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?view=fy-carte')
        .then(function (response) { return response.ok ? response.text() : ''; })
        .catch(function () { return ''; });
    }));

    var kept = [];
    grid.innerHTML = '';
    results.forEach(function (html, index) {
      html = (html || '').trim();
      // Produit supprimé ou introuvable : on le retire discrètement de la liste.
      if (html.indexOf('<product-card') !== 0) return;
      kept.push(handles[index]);
      var holder = document.createElement('template');
      holder.innerHTML = html;
      grid.appendChild(holder.content);
    });

    if (kept.length !== handles.length) {
      try { localStorage.setItem(KEY, JSON.stringify(kept)); } catch (e) {}
    }

    refresh();
    showState(kept.length ? 'list' : 'empty');
  }

  /* Démarrage
   * ---------------------------------------------------------------------------------------------------------------- */
  decorate(document);
  refresh();
  renderPage();

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      Array.prototype.forEach.call(record.addedNodes, decorate);
    });
  }).observe(document.body, { childList: true, subtree: true });

  window.fyFavoris = { list: read, has: has, toggle: toggle };
})();
